import c from './Const'

export const _host_ =  window.location.hostname+":"+c.PORT;
export function sendToServer(value, path) {

    //console.log("sendToServer")
    //console.log(value)

    fetch('http://'+_host_+'/rest/'+ path, {
        method: 'POST',
        body: JSON.stringify(value)
    }).then(function (response) {

    });
}

function send_cs_drive(cc) {
    let cx = {}
    cx.id = c.uuidv4()
    cx.type = "cmd"
    cx.cmd = "MSG_CS_DRIVE"
    cx.target = cc

    //console.log(cx)

    sendToServer(cx, 'plan')
}

function send_plan_cmd(cc) {
    cc.id = c.uuidv4()
    cc.type = "cmd"

    console.log(cc)

    sendToServer(cc, 'plan')
}

export function send_bidib_cmd(cc) {
    const ccx = {
        id: c.uuidv4(),
        cmd: cc.cmd,
        target: cc,
    }

    console.log(ccx)
    sendToServer(ccx, 'bidib')
}

export function send_lc_cmd(cc) {

    send_cs_drive(cc)
}

export function send_getcv_cmd(cc) {
    cc.cmd = "getcv"
    cc.lcid = cc.lcid || cc.id

    send_plan_cmd(cc)
}

export function send_setcv_cmd(cc) {
    cc.cmd = "setcv"
    cc.lcid = cc.lcid || cc.id
    send_plan_cmd(cc)
}

export function send_ac_cmd(cc) {
    //cc.itemid = cc.itemid || cc.id

    let cx = {
        cmd: 'accessoryset',
        target: cc
    }

    send_plan_cmd(cx)
}

export function send_dccgen_cmd(cc) {
    cc.cmd = 'dccgen'
    send_bidib_cmd(cc)
}

export function send_booster_cmd(cc) {
    cc.cmd = 'booster'
    send_bidib_cmd(cc)
}

export function send_fw_update(cc) {
    cc.cmd = 'fwupdate'
    send_bidib_cmd(c)
}

export function send_identify(cc) {
    cc.cmd = 'identify'
    send_bidib_cmd(cc)
}

export function send_bidib_edit_cmd(cc) {
    cc.cmd = 'edit'
    send_bidib_cmd(cc)
}

export function send_bidib_msg(cc) {
    cc.cmd = 'bidib_msg'
    send_bidib_cmd(cc)
}

export function send_route_cmd(cc) {


    cc.cmd = "route_set"
    //cc.itemid = cc.itemid || cc.id

    console.log(cc)
    sendToServer(cc, 'plan')
}

export function send_edit_cmd(cc) {
    let cx = {
        cmd: 'edit',
        target: cc
    }

    send_plan_cmd(cx)
}

export function send_add_cmd(cc) {
    let cx = {
        cmd: 'add',
        target: cc
    }

    send_plan_cmd(cx)
}

export function send_action_cmd(cc, action) {
    let cx = {
        cmd: action,
        target: cc
    }

    send_plan_cmd(cx)
}

export function send_system_cmd(cc) {
    let cx = {
        type: 'system',
        target: cc
    }
    send_plan_cmd(cx)
}
